var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FCLinkButton',_vm._b({attrs:{"tracking-id":_vm.sectionId}},'FCLinkButton',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }